export default remote => ({
    newTicket: (data) => remote.put('support/ticket/any-flight', data)
});
